/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Open_RecentInputs */



/**
* | output |
* | --- |
* | "Open Recent" |
*
* @param {Open_RecentInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const open_recent = /** @type {((inputs?: Open_RecentInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Open_RecentInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Projets récents")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zuletzt geöffnet")
	if (locale === "it") return /** @type {LocalizedString} */ ("Apri recenti")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Открыть недавние")
	if (locale === "es") return /** @type {LocalizedString} */ ("Abrir reciente")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("最近打开")
	if (locale === "ja") return /** @type {LocalizedString} */ ("最近開いた")
	if (locale === "hi") return /** @type {LocalizedString} */ ("हाल ही वाला खोलें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Abrir recentes")
	return /** @type {LocalizedString} */ ("Open Recent")
});